import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { TargetIcon, ArrowRightIcon, ShieldCheckIcon } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};
export function ThreeDoorsSection() {
  return <section className="bg-[#111111] px-5 py-16 md:py-24" data-id="element-246">
      <motion.div className="max-w-3xl mx-auto" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} data-id="element-247">
        <motion.h2 variants={itemVariants} className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6" data-id="element-248">
          El problema real: tus ventas mueren en una de{' '}
          <span className="text-[#E8732A]" data-id="element-249">3 puertas</span>
        </motion.h2>

        <motion.p variants={itemVariants} className="text-[#A0A0A0] text-lg md:text-xl leading-relaxed mb-12" data-id="element-250">
          Una conversión es un pasillo con 3 puertas:
        </motion.p>

        <div className="space-y-6 mb-12" data-id="element-251">
          <motion.div variants={itemVariants} className="bg-[#0A0A0A] p-6 rounded-lg border border-[#2A2A2A] flex items-start gap-4" data-id="element-252">
            <div className="flex-shrink-0 w-12 h-12 bg-[#E8732A]/10 rounded-full flex items-center justify-center" data-id="element-253">
              <TargetIcon className="w-6 h-6 text-[#E8732A]" data-id="element-254" />
            </div>
            <div data-id="element-255">
              <p className="text-white text-xl font-bold mb-2" data-id="element-256">
                <span className="text-[#E8732A]" data-id="element-257">1.</span> Oferta correcta
              </p>
              <p className="text-[#A0A0A0] text-lg" data-id="element-258">¿Esto es para mí?</p>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-[#0A0A0A] p-6 rounded-lg border border-[#2A2A2A] flex items-start gap-4" data-id="element-259">
            <div className="flex-shrink-0 w-12 h-12 bg-[#E8732A]/10 rounded-full flex items-center justify-center" data-id="element-260">
              <ArrowRightIcon className="w-6 h-6 text-[#E8732A]" data-id="element-261" />
            </div>
            <div data-id="element-262">
              <p className="text-white text-xl font-bold mb-2" data-id="element-263">
                <span className="text-[#E8732A]" data-id="element-264">2.</span> Puente correcto
              </p>
              <p className="text-[#A0A0A0] text-lg" data-id="element-265">
                ¿Cómo lo obtengo sin complicarme?
              </p>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-[#0A0A0A] p-6 rounded-lg border border-[#2A2A2A] flex items-start gap-4" data-id="element-266">
            <div className="flex-shrink-0 w-12 h-12 bg-[#E8732A]/10 rounded-full flex items-center justify-center" data-id="element-267">
              <ShieldCheckIcon className="w-6 h-6 text-[#E8732A]" data-id="element-268" />
            </div>
            <div data-id="element-269">
              <p className="text-white text-xl font-bold mb-2" data-id="element-270">
                <span className="text-[#E8732A]" data-id="element-271">3.</span> Prueba correcta
              </p>
              <p className="text-[#A0A0A0] text-lg" data-id="element-272">
                ¿Por qué debería creerte?
              </p>
            </div>
          </motion.div>
        </div>

        <motion.div variants={itemVariants} className="bg-[#E8732A]/10 border border-[#E8732A]/30 p-6 md:p-8 rounded-lg" data-id="element-273">
          <p className="text-white text-lg md:text-xl leading-relaxed mb-4" data-id="element-274">
            Si una puerta falla,{' '}
            <span className="text-[#E8732A] font-semibold" data-id="element-275">
              tu tráfico se vuelve entretenimiento.
            </span>
          </p>
          <p className="text-[#A0A0A0] text-lg md:text-xl leading-relaxed" data-id="element-276">
            Eso explica la sensación rara de: "me miran… pero no me compran."
          </p>
        </motion.div>
      </motion.div>
    </section>;
}